import React from "react";
import { Link, useNavigate } from "react-router-dom";
import LogoTemplate from "../../../Assets/images/logoh.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
export const LocalShops = ({shopList:shopData} ) => {
  const roundValue = (number) => {
    const formattedNumber = number % 1 === 0 ? parseInt(number) : number;
    return formattedNumber;
  };
  const navigate = useNavigate()
  return (
    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 panel-body">
      {shopData?.dt?.map((product) => (
        <div key={product?.CatId} className="col mb-4">
          <div className="card-with-shadow">
            <Link to={`/shopprofilelocal/${product?.ShopId}`}>
              <div className="shop-card-header">
                <img
                  src={product?.Logo || LogoTemplate}
                  className="card-img-top "
                  alt={product?.Title}
                />
              </div>
            </Link>
            <div className="shop-card-body d-flex justify-content-center align-items-center">
              <div className="d-flex justify-content-between " >
                <Link to={`/shopprofilelocal/${product?.ShopId}`} className="text-decoration-none text-dark">
                <h4 className="card-title">{product?.Title}</h4>
                </Link>
                {/* <p className="card-text">دسته بندی</p> */}
              </div>
              <div className="d-flex  justify-content-between align-items-center ">
                <div className="shop-card-text">
                  <FontAwesomeIcon icon="coins" className="text-warning fs-6" />
                  <span className="card-text">
                    {" "}
                    {roundValue(product?.MinimumCashBack)}
                  </span>
                  <span className="card-text">
                    {" "}
                    تا {roundValue(product?.MaxsimumCashBack) || ""}% کش بک
                  </span>
                </div>
                <div>
                  {/* <Link to={`https://${product?.WebSite}?R=taab30`}>
                    <button className="btn btn-light">ورود به فروشگاه</button>
                  </Link> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
